import { render } from "./LabsLightbulb.vue?vue&type=template&id=1b2338fb&scoped=true"
import script from "./LabsLightbulb.vue?vue&type=script&lang=js"
export * from "./LabsLightbulb.vue?vue&type=script&lang=js"

import "./LabsLightbulb.vue?vue&type=style&index=0&id=1b2338fb&scoped=true&lang=css"

import exportComponent from "/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2338fb"]])

export default __exports__